import { AutogenModelEdiStandardCode, AutogenRowEdiStandardCode } from "./autogen/AutogenModelEdiStandardCode";

export class ModelEdiStandardCode extends AutogenModelEdiStandardCode<RowEdiStandardCode> {
    constructor() {
        super(RowEdiStandardCode);
    }
}

export class RowEdiStandardCode extends AutogenRowEdiStandardCode {
}